<template>
    <div class="sign-up">
        <div class="wrapper">
            <img
                class="logo"
                :src="require('@/assets/moodmix-logo.png')"
            />

            <form class="form" @submit.prevent="submit()">
                <div class="form-wrapper">
                    <span class="label">First Name</span>
                    <input
                        v-model="first"
                        class="firstname"
                        type="text"
                        placeholder="Input first name"
                        required
                    >
                </div>

                <div class="form-wrapper">
                    <span class="label">Last Name</span>
                    <input 
                        v-model="last"
                        class="lastname" 
                        type="text" 
                        placeholder="Input last name" 
                        required
                    >
                </div>

                <div class="form-wrapper">
                    <span class="label">Email</span>
                    <input
                        v-model="email"
                        class="email" 
                        type="email" 
                        placeholder="Input email" 
                        required
                    >
                    <p class="error" v-if="error.email">{{ error.email[0] }}</p>
                </div>
                
                <div class="form-wrapper">
                    <span class="label">Password</span>
                    <div class="password-wrapper">
                        <input
                            v-model="pass"
                            class="password" 
                            :type="showPass ? 'text' : 'password'" 
                            placeholder="Input password" 
                            required
                        >
                        <p class="show" @click="showPass = !showPass">{{ showPass ? 'Hide' : 'Show' }}</p>
                        <p class="error" v-if="error.password">{{ error.password[0] }}</p>
                    </div>
                </div>

                <div class="form-wrapper">
                    <span class="label">Confirm Password</span>
                    <div class="password-wrapper">
                        <input
                            v-model="confirmPass"
                            class="password"
                            :type="showConfirmPass ? 'text' : 'password'"
                            placeholder="Input confirm password"
                            required
                        >
                        <p class="show" @click="showConfirmPass = !showConfirmPass">{{ showConfirmPass ? 'Hide' : 'Show' }}</p>
                    </div>
                </div>

                <button class="login" type="submit" :disabled="loading">Create</button>
            </form>

            <router-link 
                class="link"
                :to="{ name: 'SignIn' }"
                :disabled="loading"
            >
                Already have an account? Sign in
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
export default {
	data () {
		return {
			first: '',
			last: '',
			email: '',
			pass: '',
			confirmPass: '',
            
			showPass: false,
			showConfirmPass: false,
		}
	},
    
	computed: {
		...mapState({
			loading: state => state.loading,
			error: state => state.signUpError,
		})
	},
    
	destroyed() {
		this.$store.commit('SET_SIGN_UP_ERROR', {})
	},
    
	methods: {
		async submit () {
			if (process.env.VUE_APP_SERVER !== 'test') {
				this.$store.commit('SET_LOADING', true)
				let bouncerResult = await axios({
					method: 'get',
					url: 'https://api.usebouncer.com/v1/email/verify',
					headers: { 'X-API-KEY': 'LB5Mvl0Xefy6uFhBhFGTVtiz6JA66e15Q2DWS5Jk' },
					params: { email: this.email }
				})

				if (bouncerResult.data.status !== 'deliverable') {
					this.$store.commit('SET_SIGN_UP_ERROR', {
						email: ['Please input a valid email.']
					})
					this.$store.commit('SET_LOADING', false)
					return
				}
			}

			let result = await this.$store.dispatch('signUp', {
				name: `${this.first} ${this.last}`,
				email: this.email,
				password: this.pass,
				password_confirmation: this.confirmPass,
			})
            
			if (result) {
				this.first = ''
				this.last = ''
				this.email = ''
				this.pass = ''
				this.confirmPass = ''
				this.$router.push({name: 'SignIn'})
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.sign-up {
    padding-top: 55px;

    .wrapper {
        display: flex;
        flex-direction: column;
        margin: auto;
        width: 400px;

        @include mobile {
            width: 300px;
        }

        .logo {
            width: 123px;
            height: 61px;
            margin: 0 auto 35px;
        }

        .form {
            display: flex;
            flex-direction: column;

            .label {
                color: #ffffff;
                margin-bottom: 10px;
            }

            .form-wrapper {
                display: flex;
                flex-direction: column;
                margin-bottom: 30px;

                .error {
                    text-align: right;
                    color: #F4949A;
                    font-size: 12px;
                }
            }

            .password-wrapper {
                position: relative;

                .password {
                    width: 100%;
                    padding-right: 45px;
                }

                .show {
                    color: #BFCCE2;
                    position: absolute;
                    top: 7px;
                    right: 10px;
                    cursor: pointer;
                }
            }

            input {
                padding: 5px;
                border: 1px solid #BFCCE2;
                border-radius: 3px;
                opacity: 1;
                margin-bottom: 5px;
                height: 32px;

                &::placeholder {
                    opacity: 1;
                    color: #BFCCE2;
                    font-size: 12px;
                }
            }

            button {
                width: 242px;
                margin: 0px auto 50px;
            }
        }

        

        .link {
            color: #47CBBF;
            text-align: center;
            font-size: 16px;
            margin-bottom: 60px;
        }
    }
}
</style>